package com.exura.features.publicplans.domain.model

import com.exura.features.publicplans.data.remote.dto.AnonymousPublicPlanOrderDto
import com.exura.features.storage.domain.model.DomainModel
import kotlinx.datetime.LocalDateTime

data class AnonymousPublicPlanOrder(
    override val id: String?,
    val sourcePlanId: String,
    val accessedDate: LocalDateTime,
    val anchorDate: LocalDateTime,
    val orderDuration: Int,
) : DomainModel<AnonymousPublicPlanOrder, AnonymousPublicPlanOrderDto> {
    override fun toDto(): AnonymousPublicPlanOrderDto = AnonymousPublicPlanOrderDto(
        sourcePlanId = this.sourcePlanId,
        accessedDate = this.accessedDate.toString(),
        anchorDate = this.anchorDate.toString(),
        orderDuration = this.orderDuration,
    )

    override fun withId(id: String): AnonymousPublicPlanOrder = copy(id = id)

    companion object : DomainModel.Factory<AnonymousPublicPlanOrder, AnonymousPublicPlanOrderDto> {
        override fun fromDto(id: String?, dto: AnonymousPublicPlanOrderDto): AnonymousPublicPlanOrder =
            AnonymousPublicPlanOrder(
                id = id,
                sourcePlanId = dto.sourcePlanId,
                accessedDate = LocalDateTime.parse(dto.accessedDate),
                anchorDate = LocalDateTime.parse(dto.anchorDate),
                orderDuration = dto.orderDuration,
            )
    }
}
